import { ScamProtocol } from '../types'

export const scamProtocols: ScamProtocol[] = [
  {
    id: 'social-engineering',
    title: {
      en: 'Social Engineering & Impersonation',
      id: 'Rekayasa Sosial & Penyamaran',
      ms: 'Kejuruteraan Sosial & Penyamaran',
      th: 'วิศวกรรมสังคมและการปลอมตัว',
      vi: 'Kỹ thuật thao túng xã hội',
      fil: 'Social Engineering at Pagpapanggap',
      km: 'វិស្វកម្មសង្គមនិងការក្លែងបន្លំ',
      lo: 'ວິສະວະກຳສັງຄົມ ແລະ ການປອມຕົວ',
      my: 'လူမှုရေးအင်ဂျင်နီယာနှင့် အယောင်ဆောင်ခြင်း',
    },
    description: {
      en: 'Scammers pretending to be officials, friends, or family to manipulate you into sending money or data.',
      id: 'Penipu berpura-pura menjadi pejabat, teman, atau keluarga untuk memanipulasi Anda agar mengirim uang atau data.',
      ms: 'Penipu menyamar sebagai pegawai rasmi, rakan, atau keluarga untuk memanipulasi anda menghantar wang atau data.',
      th: 'ผู้หลอกลวงแอบอ้างเป็นเจ้าหน้าที่ เพื่อน หรือครอบครัวเพื่อหลอกให้คุณส่งเงินหรือข้อมูล',
      vi: 'Kẻ lừa đảo giả danh quan chức, bạn bè hoặc gia đình để thao túng bạn gửi tiền hoặc dữ liệu.',
      fil: 'Mga scammer na nagpapanggap na mga opisyal, kaibigan, o pamilya upang manipulahin ka na magpadala ng pera o data.',
      km: 'ជនក្លែងបន្លំជាមន្ត្រីរដ្ឋ មិត្តភក្តិ ឬគ្រួសារដើម្បីរៀបចំអ្នកឱ្យផ្ញើលុយឬទិន្នន័យ',
      lo: 'ຜູ້ຫຼອກລວງປອມຕົວເປັນເຈົ້າໜ້າທີ່ ໝູ່ເພື່ອນ ຫຼື ຄອບຄົວເພື່ອຫຼອກໃຫ້ທ່ານສົ່ງເງິນຫຼືຂໍ້ມູນ',
      my: 'လိမ်လည်သူများသည် အရာရှိများ၊ မိတ်ဆွေများ သို့မဟုတ် မိသားစုဝင်များအဖြစ် ဟန်ဆောင်ကာ ငွေ သို့မဟုတ် ဒေတာပို့ရန် လှည့်စားသည်။',
    },
    icon: 'Users',
    steps: {
      en: [
        'Verify the identity independently. Do not use contact info provided by the caller.',
        'Hang up immediately if they pressure you.',
        'Call the official organization directly using a number from their website.',
        'Never share OTPs or passwords.',
      ],
      id: [
        'Verifikasi identitas secara mandiri. Jangan gunakan info kontak yang diberikan penelepon.',
        'Tutup telepon segera jika mereka menekan Anda.',
        'Hubungi organisasi resmi secara langsung menggunakan nomor dari situs web mereka.',
        'Jangan pernah membagikan OTP atau kata sandi.',
      ],
    },
    warningSigns: {
      en: [
        'Urgent request for money or information',
        'Threats of arrest or legal action',
        'Request for secrecy',
        'Unusual payment methods (gift cards, crypto)',
      ],
      id: [
        'Permintaan uang atau informasi yang mendesak',
        'Ancaman penangkapan atau tindakan hukum',
        'Permintaan untuk merahasiakan',
        'Metode pembayaran tidak biasa (kartu hadiah, kripto)',
      ],
    },
    evidenceChecklist: {
      en: [
        'Phone number of caller',
        'Call duration and time',
        'Recordings of the call (if any)',
        'Messages or emails received',
      ],
      id: [
        'Nomor telepon penelepon',
        'Durasi dan waktu panggilan',
        'Rekaman panggilan (jika ada)',
        'Pesan atau email yang diterima',
      ],
    },
  },
  {
    id: 'investment-crypto',
    title: {
      en: 'Investment & Crypto Scams',
      id: 'Penipuan Investasi & Kripto',
      ms: 'Penipuan Pelaburan & Kripto',
      th: 'การหลอกลวงการลงทุนและคริปโต',
      vi: 'Lừa đảo đầu tư & tiền mã hóa',
      fil: 'Investment at Crypto Scams',
      km: 'ការបោកប្រាស់ការវិនិយោគនិងគ្រីបតូ',
      lo: 'ການຫຼອກລວງການລົງທຶນ ແລະ ຄຣິບໂຕ',
      my: 'ရင်းနှီးမှုနှင့် ကရစ်ပတိုလိမ်လည်မှု',
    },
    description: {
      en: 'Fake investment opportunities promising high returns with little risk, often involving cryptocurrency.',
      id: 'Peluang investasi palsu yang menjanjikan keuntungan tinggi dengan risiko kecil, seringkali melibatkan mata uang kripto.',
      ms: 'Peluang pelaburan palsu yang menjanjikan pulangan tinggi dengan risiko rendah, sering melibatkan mata wang kripto.',
      th: 'โอกาสการลงทุนปลอมที่สัญญาผลตอบแทนสูงโดยมีความเสี่ยงต่ำ มักเกี่ยวข้องกับสกุลเงินดิจิทัล',
      vi: 'Cơ hội đầu tư giả mạo hứa hẹn lợi nhuận cao với rủi ro thấp, thường liên quan đến tiền mã hóa.',
      fil: 'Mga pekeng oportunidad sa investment na nangangako ng mataas na kita na may mababang panganib, kadalasang may kinalaman sa cryptocurrency.',
      km: 'ឱកាសវិនិយោគក្លែងបន្លំដែលសន្យាផលចំណេញខ្ពស់ដោយមានហានិភ័យតិច ជាញឹកញាប់ពាក់ព័ន្ធនឹងរូបិយប័ណ្ណគ្រីបតូ',
      lo: 'ໂອກາດການລົງທຶນປອມທີ່ສັນຍາຜົນຕອບແທນສູງດ້ວຍຄວາມສ່ຽງຕໍ່າ ມັກກ່ຽວຂ້ອງກັບສະກຸນເງິນດິຈິຕອນ',
      my: 'အန္တရာယ်နည်းပြီး အမြတ်အစွန်းမြင့်မားသည့် အတုအယောင် ရင်းနှီးမြှုပ်နှံမှုအခွင့်အလမ်းများ၊ များသောအားဖြင့် ကရစ်ပတိုငွေကြေးနှင့် ပတ်သက်သည်။',
    },
    icon: 'TrendingUp',
    steps: {
      en: [
        'Stop sending money immediately.',
        'Do not pay "withdrawal fees" or "taxes" to get your money back.',
        'Report the wallet address to crypto exchanges.',
        'Contact your bank if you transferred fiat currency.',
      ],
      id: [
        'Berhenti mengirim uang segera.',
        'Jangan membayar "biaya penarikan" atau "pajak" untuk mendapatkan uang Anda kembali.',
        'Laporkan alamat dompet ke bursa kripto.',
        'Hubungi bank Anda jika Anda mentransfer mata uang fiat.',
      ],
    },
    warningSigns: {
      en: [
        'Guaranteed high returns',
        'Pressure to invest quickly',
        'Unknown or unregulated platforms',
        'Communication via social media or dating apps',
      ],
      id: [
        'Jaminan keuntungan tinggi',
        'Tekanan untuk berinvestasi dengan cepat',
        'Platform yang tidak dikenal atau tidak diatur',
        'Komunikasi melalui media sosial atau aplikasi kencan',
      ],
    },
    evidenceChecklist: {
      en: [
        'Website URLs',
        'Crypto wallet addresses',
        'Transaction hashes (TXIDs)',
        'Screenshots of conversations and dashboards',
      ],
      id: [
        'URL situs web',
        'Alamat dompet kripto',
        'Hash transaksi (TXID)',
        'Tangkapan layar percakapan dan dasbor',
      ],
    },
  },
  {
    id: 'romance-scam',
    title: {
      en: 'Romance Scam',
      id: 'Penipuan Asmara',
      ms: 'Penipuan Percintaan',
      th: 'การหลอกลวงด้านความรัก',
      vi: 'Lừa đảo tình cảm',
      fil: 'Romance Scam',
      km: 'ការបោកប្រាស់ស្នេហា',
      lo: 'ການຫຼອກລວງດ້ານຄວາມຮັກ',
      my: 'အချစ်ရေးလိမ်လည်မှု',
    },
    description: {
      en: 'Building fake romantic relationships to exploit victims financially and emotionally.',
      id: 'Membangun hubungan romantis palsu untuk mengeksploitasi korban secara finansial dan emosional.',
      ms: 'Membina hubungan romantis palsu untuk mengeksploitasi mangsa dari segi kewangan dan emosi.',
      th: 'สร้างความสัมพันธ์ทางความรักปลอมเพื่อหลอกเอาเงินและจิตใจของเหยื่อ',
      vi: 'Xây dựng mối quan hệ tình cảm giả để khai thác nạn nhân về tài chính và tinh thần.',
      fil: 'Pagbuo ng pekeng romantikong relasyon upang samantalahin ang mga biktima sa pananalapi at emosyonal.',
      km: 'បង្កើតទំនាក់ទំនងស្នេហាក្លែងបន្លំដើម្បីកេងប្រវ័ញ្ចជនរងគ្រោះផ្នែកហិរញ្ញវត្ថុនិងអារម្មណ៍',
      lo: 'ສ້າງຄວາມສຳພັນທາງຄວາມຮັກປອມເພື່ອຫຼອກເອົາເງິນແລະຈິດໃຈຂອງຜູ້ຖືກເຄາະຮ້າຍ',
      my: 'ငွေကြေးနှင့် စိတ်ခံစားမှုအရ သားကောင်များကို အမြတ်ထုတ်ရန် အတုအယောင် ချစ်ခင်ရင်းနှီးမှုများ တည်ဆောက်ခြင်း။',
    },
    icon: 'Heart',
    steps: {
      en: [
        'Stop all communication immediately.',
        'Do not send any more money or gifts.',
        'Block the person on all platforms.',
        'Report the profile to the dating app or social media platform.',
      ],
      id: [
        'Hentikan semua komunikasi segera.',
        'Jangan mengirim uang atau hadiah lagi.',
        'Blokir orang tersebut di semua platform.',
        'Laporkan profil ke aplikasi kencan atau platform media sosial.',
      ],
    },
    warningSigns: {
      en: [
        'Professes love very quickly',
        'Never wants to meet in person or video call',
        'Has elaborate sob stories',
        'Asks for money for emergencies',
      ],
      id: [
        'Menyatakan cinta dengan sangat cepat',
        'Tidak pernah ingin bertemu langsung atau video call',
        'Memiliki cerita sedih yang rumit',
        'Meminta uang untuk keadaan darurat',
      ],
    },
    evidenceChecklist: {
      en: [
        'Profile screenshots',
        'All messages and emails',
        'Photos they sent',
        'Payment receipts',
      ],
      id: [
        'Tangkapan layar profil',
        'Semua pesan dan email',
        'Foto yang mereka kirim',
        'Bukti pembayaran',
      ],
    },
  },
  {
    id: 'phishing-account-takeover',
    title: {
      en: 'Phishing & Account Takeover',
      id: 'Phishing & Pengambilalihan Akun',
      ms: 'Phishing & Pengambilalihan Akaun',
      th: 'ฟิชชิ่งและการยึดบัญชี',
      vi: 'Lừa đảo qua email & chiếm đoạt tài khoản',
      fil: 'Phishing at Pag-agaw ng Account',
      km: 'ហ្វីស៊ីងនិងការដណ្តើមយកគណនី',
      lo: 'ຟິຊຊິງ ແລະ ການຍຶດເອົາບັນຊີ',
      my: 'ဖစ်ရှင်းနှင့် အကောင့်သိမ်းယူခြင်း',
    },
    description: {
      en: 'Fraudulent attempts to obtain sensitive information through fake emails, messages, or websites.',
      id: 'Upaya penipuan untuk mendapatkan informasi sensitif melalui email, pesan, atau situs web palsu.',
      ms: 'Percubaan penipuan untuk mendapatkan maklumat sensitif melalui e-mel, mesej, atau laman web palsu.',
      th: 'ความพยายามฉ้อโกงเพื่อขอข้อมูลที่ละเอียดอ่อนผ่านอีเมล ข้อความ หรือเว็บไซต์ปลอม',
      vi: 'Nỗ lực gian lận để lấy thông tin nhạy cảm qua email, tin nhắn hoặc trang web giả mạo.',
      fil: 'Mga mapanlinlang na pagtatangka na makakuha ng sensitibong impormasyon sa pamamagitan ng pekeng email, mensahe, o website.',
      km: 'ការព្យាយាមបោកប្រាស់ដើម្បីទទួលបានព័ត៌មានរសើបតាមរយៈអ៊ីមែល សារ ឬគេហទំព័រក្លែងបន្លំ',
      lo: 'ຄວາມພະຍາຍາມຫຼອກລວງເພື່ອໄດ້ຮັບຂໍ້ມູນທີ່ລະອຽດອ່ອນຜ່ານອີເມລ ຂໍ້ຄວາມ ຫຼື ເວັບໄຊທ໌ປອມ',
      my: 'အတုအယောင် အီးမေးလ်များ၊ မက်ဆေ့ခ်ျများ သို့မဟုတ် ဝက်ဘ်ဆိုက်များမှတစ်ဆင့် အရေးကြီးသော အချက်အလက်များကို ရယူရန် လိမ်လည်မှုကြိုးပမ်းမှုများ။',
    },
    icon: 'Lock',
    steps: {
      en: [
        'Do not click any links or download attachments.',
        'Change your passwords immediately if you clicked anything.',
        'Enable two-factor authentication on all accounts.',
        'Report the phishing attempt to the legitimate organization.',
      ],
      id: [
        'Jangan klik tautan atau unduh lampiran apa pun.',
        'Ubah kata sandi Anda segera jika Anda mengklik sesuatu.',
        'Aktifkan autentikasi dua faktor di semua akun.',
        'Laporkan upaya phishing ke organisasi yang sah.',
      ],
    },
    warningSigns: {
      en: [
        'Suspicious sender email address',
        'Urgent language or threats',
        'Requests for passwords or OTPs',
        'Poor grammar or spelling',
      ],
      id: [
        'Alamat email pengirim yang mencurigakan',
        'Bahasa mendesak atau ancaman',
        'Permintaan kata sandi atau OTP',
        'Tata bahasa atau ejaan yang buruk',
      ],
    },
    evidenceChecklist: {
      en: [
        'Full email with headers',
        'Suspicious URLs',
        'Screenshots of fake websites',
        'Any account activity logs',
      ],
      id: [
        'Email lengkap dengan header',
        'URL yang mencurigakan',
        'Tangkapan layar situs web palsu',
        'Log aktivitas akun apa pun',
      ],
    },
  },
  {
    id: 'marketplace-payment',
    title: {
      en: 'Marketplace & Payment Scams',
      id: 'Penipuan Marketplace & Pembayaran',
      ms: 'Penipuan Pasaran & Pembayaran',
      th: 'การหลอกลวงในตลาดออนไลน์และการชำระเงิน',
      vi: 'Lừa đảo thương mại điện tử & thanh toán',
      fil: 'Marketplace at Payment Scams',
      km: 'ការបោកប្រាស់ទីផ្សារនិងការទូទាត់',
      lo: 'ການຫຼອກລວງຕະຫຼາດອອນໄລນ໌ ແລະ ການຊຳລະເງິນ',
      my: 'အွန်လိုင်းဈေးကွက်နှင့် ငွေပေးချေမှုလိမ်လည်မှု',
    },
    description: {
      en: 'Scams involving fake sellers, non-delivery of goods, or fraudulent payment requests.',
      id: 'Penipuan yang melibatkan penjual palsu, barang tidak dikirim, atau permintaan pembayaran palsu.',
      ms: 'Penipuan yang melibatkan penjual palsu, barang tidak dihantar, atau permintaan pembayaran penipuan.',
      th: 'การหลอกลวงที่เกี่ยวข้องกับผู้ขายปลอม สินค้าไม่ส่ง หรือคำขอชำระเงินที่เป็นการฉ้อโกง',
      vi: 'Lừa đảo liên quan đến người bán giả, không giao hàng hoặc yêu cầu thanh toán gian lận.',
      fil: 'Mga scam na may kinalaman sa mga pekeng nagbebenta, hindi paghahatid ng produkto, o mapanlinlang na kahilingan sa pagbabayad.',
      km: 'ការបោកប្រាស់ដែលពាក់ព័ន្ធនឹងអ្នកលក់ក្លែងបន្លំ ទំនិញមិនបានដឹកជញ្ជូន ឬសំណើទូទាត់ប្រាក់បោកប្រាស់',
      lo: 'ການຫຼອກລວງທີ່ກ່ຽວຂ້ອງກັບຜູ້ຂາຍປອມ ສິນຄ້າບໍ່ສົ່ງ ຫຼື ການຮ້ອງຂໍການຊຳລະເງິນທີ່ຫຼອກລວງ',
      my: 'အတုအယောင် ရောင်းသူများ၊ ကုန်ပစ္စည်းမပို့ခြင်း သို့မဟုတ် လိမ်လည်သော ငွေပေးချေမှုတောင်းဆိုမှုများနှင့် ပတ်သက်သော လိမ်လည်မှုများ။',
    },
    icon: 'ShoppingBag',
    steps: {
      en: [
        'Stop all communication with the seller.',
        'Report the seller to the marketplace platform.',
        'Contact your payment provider to dispute the charge.',
        'File a report with consumer protection authorities.',
      ],
      id: [
        'Hentikan semua komunikasi dengan penjual.',
        'Laporkan penjual ke platform marketplace.',
        'Hubungi penyedia pembayaran Anda untuk mempersengketakan biaya.',
        'Ajukan laporan ke otoritas perlindungan konsumen.',
      ],
    },
    warningSigns: {
      en: [
        'Price too good to be true',
        'Seller insists on payment outside platform',
        'No reviews or suspicious reviews',
        'Requests for unusual payment methods',
      ],
      id: [
        'Harga terlalu bagus untuk menjadi kenyataan',
        'Penjual bersikeras pembayaran di luar platform',
        'Tidak ada ulasan atau ulasan mencurigakan',
        'Permintaan metode pembayaran yang tidak biasa',
      ],
    },
    evidenceChecklist: {
      en: [
        'Product listings and screenshots',
        'All messages with seller',
        'Payment receipts',
        'Tracking information (if any)',
      ],
      id: [
        'Daftar produk dan tangkapan layar',
        'Semua pesan dengan penjual',
        'Bukti pembayaran',
        'Informasi pelacakan (jika ada)',
      ],
    },
  },
  {
    id: 'sextortion-blackmail',
    title: {
      en: 'Sextortion & Digital Blackmail',
      id: 'Sextortion & Pemerasan Digital',
      ms: 'Sextortion & Pemerasan Digital',
      th: 'การขู่กรรโชกทางเพศและการแบล็กเมล์ดิจิทัล',
      vi: 'Tống tiền tình dục & tống tiền kỹ thuật số',
      fil: 'Sextortion at Digital Blackmail',
      km: 'ការជំរិតផ្លូវភេទនិងការគំរាមកំហែងឌីជីថល',
      lo: 'ການຂົ່ມຂູ່ທາງເພດ ແລະ ການຂູ່ກູ້ດິຈິຕອນ',
      my: 'လိင်ပိုင်းဆိုင်ရာ ခြိမ်းခြောက်ခြင်းနှင့် ဒစ်ဂျစ်တယ်ငွေညှစ်ခြင်း',
    },
    description: {
      en: 'Threats to share intimate images or videos unless payment is made.',
      id: 'Ancaman untuk membagikan gambar atau video intim kecuali pembayaran dilakukan.',
      ms: 'Ancaman untuk berkongsi imej atau video intim melainkan pembayaran dibuat.',
      th: 'การขู่ว่าจะแชร์ภาพหรือวิดีโอที่ไม่เหมาะสมหากไม่จ่ายเงิน',
      vi: 'Đe dọa chia sẻ hình ảnh hoặc video nhạy cảm trừ khi thanh toán.',
      fil: 'Mga pagbabanta na magbahagi ng mga intimate na larawan o video maliban kung magbayad.',
      km: 'ការគំរាមកំហែងចែករំលែករូបភាពឬវីដេអូផ្ទាល់ខ្លួនលុះត្រាតែមានការទូទាត់ប្រាក់',
      lo: 'ການຂົ່ມຂູ່ແບ່ງປັນຮູບພາບຫຼືວິດີໂອສ່ວນຕົວເວັ້ນເສຍແຕ່ມີການຊຳລະເງິນ',
      my: 'ငွေမပေးပါက ကိုယ်ရေးကိုယ်တာ ဓာတ်ပုံများ သို့မဟုတ် ဗီဒီယိုများကို မျှဝေမည်ဟု ခြိမ်းခြောက်ခြင်း။',
    },
    icon: 'Shield',
    steps: {
      en: [
        'Do NOT pay. Payment does not guarantee deletion.',
        'Do not engage with the blackmailer.',
        'Report to local police immediately.',
        'Secure all your accounts and change passwords.',
        'Seek support from trusted friends or counselors.',
      ],
      id: [
        'JANGAN bayar. Pembayaran tidak menjamin penghapusan.',
        'Jangan terlibat dengan pemeras.',
        'Laporkan ke polisi setempat segera.',
        'Amankan semua akun Anda dan ubah kata sandi.',
        'Cari dukungan dari teman tepercaya atau konselor.',
      ],
    },
    warningSigns: {
      en: [
        'Threats to share intimate content',
        'Demands for money via crypto or gift cards',
        'Claims to have hacked your device',
        'Countdown timers or urgent deadlines',
      ],
      id: [
        'Ancaman untuk membagikan konten intim',
        'Tuntutan uang melalui kripto atau kartu hadiah',
        'Klaim telah meretas perangkat Anda',
        'Timer hitung mundur atau tenggat waktu mendesak',
      ],
    },
    evidenceChecklist: {
      en: [
        'All threatening messages',
        'Payment demands and wallet addresses',
        'Any accounts or profiles used',
        'Timeline of events',
      ],
      id: [
        'Semua pesan ancaman',
        'Tuntutan pembayaran dan alamat dompet',
        'Akun atau profil yang digunakan',
        'Timeline kejadian',
      ],
    },
  },
  {
    id: 'job-scam',
    title: {
      en: 'Job Scams & Scam Compounds',
      id: 'Penipuan Lowongan Kerja & Pusat Operasi Penipuan',
      ms: 'Penipuan Pekerjaan & Pusat Operasi Penipuan',
      th: 'การหลอกลวงงานและศูนย์หลอกลวง',
      vi: 'Lừa đảo việc làm & trung tâm lừa đảo',
      fil: 'Job Scams at Scam Compounds',
      km: 'ការបោកប្រាស់ការងារនិងមជ្ឈមណ្ឌលប្រតិបត្តិការបោកប្រាស់',
      lo: 'ການຫຼອກລວງວຽກງານ ແລະ ສູນປະຕິບັດການຫຼອກລວງ',
      my: 'အလုပ်လိမ်လည်မှုနှင့် လိမ်လည်မှုစခန်းများ',
    },
    description: {
      en: 'Fake job offers requiring upfront payments or leading to forced labor in scam operations.',
      id: 'Tawaran pekerjaan palsu yang meminta pembayaran di muka atau mengarah pada kerja paksa dalam operasi penipuan.',
      ms: 'Tawaran pekerjaan palsu yang memerlukan bayaran pendahuluan atau membawa kepada buruh paksa dalam operasi penipuan.',
      th: 'ข้อเสนองานปลอมที่ต้องจ่ายเงินล่วงหน้าหรือนำไปสู่การบังคับใช้แรงงานในการดำเนินการหลอกลวง',
      vi: 'Đề nghị việc làm giả yêu cầu thanh toán trước hoặc dẫn đến lao động cưỡng bức trong hoạt động lừa đảo.',
      fil: 'Mga pekeng alok ng trabaho na nangangailangan ng paunang bayad o humahantong sa sapilitang paggawa sa mga operasyon ng scam.',
      km: 'ការផ្តល់ការងារក្លែងបន្លំដែលតម្រូវឱ្យមានការទូទាត់ប្រាក់ជាមុន ឬនាំទៅរកការងារបង្ខំក្នុងប្រតិបត្តិការបោកប្រាស់',
      lo: 'ການສະເໜີວຽກງານປອມທີ່ຕ້ອງການການຊຳລະເງິນລ່ວງໜ້າ ຫຼື ນຳໄປສູ່ການບັງຄັບໃຊ້ແຮງງານໃນການປະຕິບັດການຫຼອກລວງ',
      my: 'ကြိုတင်ငွေပေးချေမှု လိုအပ်သော သို့မဟုတ် လိမ်လည်မှုလုပ်ငန်းများတွင် အတင်းအကျပ် အလုပ်လုပ်ခိုင်းခြင်းသို့ ဦးတည်သော အတုအယောင် အလုပ်ကမ်းလှမ်းချက်များ။',
    },
    icon: 'Briefcase',
    steps: {
      en: [
        'Do not pay any money for "training" or "equipment".',
        'Stop all communication.',
        'If you are being held against your will, contact local embassy or emergency services immediately.',
        'Report the job posting to the platform.',
        'Warn others about the fake job offer.',
      ],
      id: [
        'Jangan membayar uang untuk "pelatihan" atau "peralatan".',
        'Hentikan semua komunikasi.',
        'Jika Anda ditahan di luar kehendak Anda, hubungi kedutaan setempat atau layanan darurat segera.',
        'Laporkan postingan pekerjaan ke platform.',
        'Peringatkan orang lain tentang tawaran pekerjaan palsu.',
      ],
    },
    warningSigns: {
      en: [
        'High salary for little work',
        'Interview via chat only',
        'Request for upfront payment',
        'Job offer in a different country with vague details',
        'No company website or verifiable information',
      ],
      id: [
        'Gaji tinggi untuk sedikit pekerjaan',
        'Wawancara hanya melalui obrolan',
        'Permintaan pembayaran di muka',
        'Tawaran pekerjaan di negara lain dengan detail yang tidak jelas',
        'Tidak ada situs web perusahaan atau informasi yang dapat diverifikasi',
      ],
    },
    evidenceChecklist: {
      en: [
        'Job advertisement copy',
        "Recruiter's profile and contact info",
        'Emails or messages exchanged',
        'Payment records',
        'Company name and claimed location',
      ],
      id: [
        'Salinan iklan pekerjaan',
        'Profil dan info kontak perekrut',
        'Email atau pesan yang dipertukarkan',
        'Catatan pembayaran',
        'Nama perusahaan dan lokasi yang diklaim',
      ],
    },
  },
]
